export function normalizeTranscriptionSegments(raw, localIdentity) {
    return raw.map((t) => ({
        id: t.streamInfo.id,
        role: t.participantInfo.identity === localIdentity ? "user" : "assistant",
        text: t.text,
        timestamp: t.streamInfo.timestamp,
        isFinal: t.streamInfo.attributes?.["lk.transcription_final"] === "true",
    }));
}
